import styled from 'styled-components'

export const Text = {
  Topic: styled.div`
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    font-size: 32px;
    font-weight: bold;
    line-height: 42px;
    letter-spacing: 1.5px;
    text-align: center;
    color: white;
  `,

  HighlightMain: styled.div`
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 1.2px;
    text-align: center;
    color: #ff730e;
  `,

  Subtitle: styled.div`
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    font-size: 18px;
    letter-spacing: 0.9px;
    color: #585858;
  `,

  SubtitleBold: styled.div`
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0.9px;
    color: #585858;
  `,

  Content: styled.div`
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: 0.8px;
    color: #585858;
  `,

  ContentWhite: styled.div`
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: 0.8px;
    color: #fff;
  `,

  ContentGray: styled.div`
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: 0.8px;
    color: #9b9b9b;
  `,

  ContentMain: styled.div`
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.8px;
    color: #ff730e;
  `,

  ContentMainLight: styled.div`
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.8px;
    color: #ff730e;
  `,

  ContentGrayLight: styled.div`
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.8px;
    color: #cdcdcd;
  `,

  Description: styled.div`
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.7px;
    color: #9b9b9b;
  `,

  LabelGray: styled.div`
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.6px;
    color: #9b9b9b;
    line-height: normal;
  `,

  LabelMain: styled.div`
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.6px;
    color: #ff730e;
    line-height: normal;
  `
}



// WEBPACK FOOTER //
// ./src/elements/Text.ts